import { CLICK_ACTIONS } from '../../utils/Constant';
import { ColumnHeaderType } from '../../utils/Types';
import {
  blankValueGetter,
  nameValueGetter,
  roleCountValueGetter,
  roleValueGetter,
} from '../../utils/Util';

export const EMPLOYEE_INFORMATION_HELPER: ColumnHeaderType[] = [
  {
    field: 'employeeUniqueId',
    name: 'Employee Id',
    valueGetter: blankValueGetter,
    clickable: true,
    action: CLICK_ACTIONS.VIEW_TASK,
    showProfilePhoto: true,
  },
  {
    field: 'employeeName',
    name: 'Employee Name',
    valueGetter: nameValueGetter,
  },
  {
    field: 'roles',
    name: 'Role',
    valueGetter: roleValueGetter,
  },
  {
    field: 'zone',
    name: 'Zone ',
    toolTipAfter: 25,
    valueGetter: blankValueGetter,
    valueFromLocalStorage: true,
  },
  {
    field: 'state',
    name: 'State',
    valueGetter: blankValueGetter,
    valueFromLocalStorage: true,
  },
  {
    field: 'reportingManagerName',
    name: 'Reporting Manager ',
    toolTipAfter: 25,
    valueGetter: blankValueGetter,
  },
  {
    field: 'employeeStatus',
    name: 'Block/Active',
    valueGetter: blankValueGetter,
  },
];

export const employeeModalTabs = [
  'Personal Details',
  'Reporting Details',
  'Reporting Manager',
  'Reportees',
];

export const ROLE_MANAGEMENT_HEADER: ColumnHeaderType[] = [
  {
    field: 'employeeUniqueId',
    name: 'Employee Id',
    valueGetter: blankValueGetter,
    clickable: true,
    action: CLICK_ACTIONS.VIEW_ROLE_DETAILS,
    showProfilePhoto: true,
  },
  {
    field: 'employeeName',
    name: 'Employee Name',
    valueGetter: nameValueGetter,
  },
  {
    field: 'roles',
    name: 'Role',
    valueGetter: roleValueGetter,
  },
  {
    field: 'zone',
    name: 'Zone ',
    toolTipAfter: 25,
    valueGetter: blankValueGetter,
    valueFromLocalStorage: true,
  },
  {
    field: 'state',
    name: 'State',
    valueGetter: blankValueGetter,
    valueFromLocalStorage: true,
  },
  {
    field: 'employeeStatus',
    name: 'Status',
    valueGetter: blankValueGetter,
  },
  {
    field: 'reportingManagerName',
    name: 'Reporting Manager ',
    toolTipAfter: 25,
    valueGetter: blankValueGetter,
  },
  {
    field: 'roles',
    name: 'Action',
    valueGetter: roleCountValueGetter,
    customComponent: true,
    customComponentName: 'ROLE-MANAGEMENT',
    clickable: true,
    action: CLICK_ACTIONS.EDIT_ROLES,
  },
];
export const EMPLOYEE_DATA_HEADER: ColumnHeaderType[] = [
  {
    field: 'employeeUniqueId',
    name: 'Employee Id',
    valueGetter: blankValueGetter,
    clickable: true,
    action: CLICK_ACTIONS.VIEW_TASK,
    showProfilePhoto: true,
  },
  {
    field: 'name',
    name: 'Employee Name',
    valueGetter: nameValueGetter,
  },
  {
    field: 'roles',
    name: 'Role',
    valueGetter: roleValueGetter,
  },
  {
    field: 'reportingManagerName',
    name: 'Reporting Manager',
    toolTipAfter: 25,
    valueGetter: blankValueGetter,
  },
  {
    field: 'zone',
    name: 'Zone ',
    valueGetter: blankValueGetter,
    valueFromLocalStorage: true,
  },
  {
    field: 'state',
    name: 'State',
    valueGetter: blankValueGetter,
    valueFromLocalStorage: true,
  },
  {
    field: 'district',
    name: 'District',
    valueGetter: blankValueGetter,
    valueFromLocalStorage: true,
  },
  {
    field: 'employeeStatus',
    name: 'Status',
    valueGetter: blankValueGetter,
  },
];
